import { render, staticRenderFns } from "./page12.vue?vue&type=template&id=f239b80c&scoped=true&"
import script from "./page12.vue?vue&type=script&lang=js&"
export * from "./page12.vue?vue&type=script&lang=js&"
import style0 from "./page12.vue?vue&type=style&index=0&id=f239b80c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f239b80c",
  null
  
)

export default component.exports